import { DebugWebGL } from 'app/views/home/webgl/debug/DebugWebGL';
import { ParticlesWebGL } from 'app/views/home/webgl/particles/ParticlesWebGL';
import { ParticlesOptimisedWebGL } from 'app/views/home/webgl/particlesOptimised/ParticlesOptimisedWebGL';
import { ShadersWebGL } from 'app/views/home/webgl/shadersWebGL/ShadersWebGL';
import type { HomeWebGL, HomeWebGLDeps, HomeWebGLType } from 'app/views/home/webgl/webgl.types';

/**
 * HomeWebGLFactory — constructs the home WebGL implementation for a
 * HomeWebGLType (config/webgl-home homeType; ?webgl= query override).
 *
 * This is the ONLY file that imports concrete implementations — everything
 * else (HomeTimeline included) talks to the contract types.
 *
 * 'particles' is the production scene; 'particles-optimised' is its SoA
 * rewrite (now the default); 'debug' (?webgl=debug) is the minimal seam-proof
 * scene; 'shaders' (?webgl=shaders) is the SoA type with ONLY the systems
 * department moved onto the GPU (docs/DESIGN-shaders-type.md §8/§9 Stage 1 —
 * opt-in, no default change).
 */
export function createHomeWebGL(type: HomeWebGLType, deps: HomeWebGLDeps): HomeWebGL {
	switch (type) {
		case 'particles':
			return new ParticlesWebGL(deps);
		case 'particles-optimised':
			return new ParticlesOptimisedWebGL(deps);
		case 'debug':
			return new DebugWebGL(deps);
		case 'shaders':
			return new ShadersWebGL(deps);
		default:
			throw new Error(`HomeWebGLFactory: unknown home WebGL type '${type}'`);
	}
}
